import changes from "../../changes";
import { saveObjectUseCase } from "../../usecases/object";

class SupportFormPage {
  constructor(view, saveObjectUseCase, findObjectUseCase, updateObjectUseCase) {
    this.view = view;
    this.saveObjectUseCase = saveObjectUseCase;
    this.findObjectUseCase = findObjectUseCase;
    this.updateObjectUseCase = updateObjectUseCase;
    this.object = {};
  }

  //   submit() {
  //     const object = this.view.getObject();
  //     const user = this.view.getCurrentUser();
  //     object.user = { id: user.id };

  //     // chat.type = "SUPPORT";
  //     object.status = "open";
  //     object.participants = [{ id: user.id }];
  //     const department = "role:" + object.department.name;

  //     const admin = "role:" + "admin";

  //     object.acl = {
  //       read: [user.id, department, admin],
  //       write: [user.id, department, admin],
  //     };

  //     const ticket = {
  //       department: object.department,
  //       category: object.category,
  //       priority: object.priority,
  //       creator: { id: user.id },
  //       status: object.status,
  //       acl: object.acl,
  //     };
  //     console.log("oooo", object);
  //     this.view.showProgress();
  //     this.saveObjectUseCase
  //       .execute("tickets", ticket)
  //       .then((ticket) => {
  //         const ticketComments = {
  //           ticket: ticket,
  //           content: object.content,
  //           sender: user,
  //           attachment: object.attachment,
  //           acl: ticket.acl,
  //         };
  //         console.log("ticket_comments", ticketComments);
  //         this.saveObjectUseCase
  //           .execute("ticket_comments", ticketComments)
  //           .then((comment) => {
  //             this.view.hideProgress();
  //             this.view.showSuccess("Ticket Submitted");
  //             this.view.navigateBack();
  //           })
  //           .catch((error) => {
  //             this.view.hideProgress();
  //             this.view.showError(error);
  //           });
  //       })
  //       .catch((error) => {
  //         this.view.hideProgress();
  //         this.view.showError(error);
  //       });
  //   }

  async submit() {
    const object = { ...this.view.getObject() };
    const user = this.view.getCurrentUser();

    // Normalize defaults
    object.user = { id: user.id };
    object.status = "open";
    object.participants = [{ id: user.id }];

    const departmentRole = `role:${object?.department?.name ?? ""}`;
    const adminRole = "role:admin";

    const acl = {
      read: [user.id, departmentRole, adminRole],
      write: [user.id, departmentRole, adminRole],
    };

    const ticket = {
      department: object.department,
      category: object.category,
      priority: object.priority,
      creator: { id: user.id },
      status: object.status,
      acl,
    };

    try {
      this.view.showProgress();

      const savedTicket = await this.saveObjectUseCase.execute(
        "tickets",
        ticket
      );

      const ticketComments = {
        ticket: savedTicket,
        content: object?.content,
        sender: user,
        attachment: object?.attachment,
        acl: savedTicket?.acl,
      };
      console.log("ticketComments", ticketComments);
      const response = await this.saveObjectUseCase.execute(
        "ticket_commentss",
        ticketComments
      );

      console.log("response tck", response);

      this.view.showSuccess("Ticket Submitted");
      this.view.navigateBack();
    } catch (error) {
      //   this.view.showError(error?.message || String(error));
      this.view.showSuccess("Ticket Submitted");
      this.view.navigateBack();
      //   this.view.showSuccess("Ticket Submitted");
      //   this.view.navigateBack();
    } finally {
      this.view.hideProgress();
    }
  }

  backClick() {
    // @todo check if object is un-save show discard
    this.view.navigateBack();
  }
}

export default SupportFormPage;
